import { createNamespacedHelpers } from 'vuex';

import { OAP_TAB_COMPONENT_NAMESPACE } from './settings';

export const { mapState, mapGetters, mapActions } = createNamespacedHelpers(
  OAP_TAB_COMPONENT_NAMESPACE
);
